/*
 * Author: Dw
 * File Created: Thursday, 25-07-10 01:59 pm
 * Last Modified: Monday, 25-07-21 10:04 am, by Dw
 */

import { create } from 'zustand';

interface AppEntryState {
  visible: boolean;
  hide: () => void;
  show: () => void;
}

export const useAppEntryStore = create<AppEntryState>((set) => ({
  visible: false,
  hide: () => {
    set({ visible: false });
  },
  show: () => {
    set({ visible: true });
  },
}));
